import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QBEOperator = _resolveComponent("QBEOperator")
  const _component_QBEGroup = _resolveComponent("QBEGroup")
  const _component_QBEFilter = _resolveComponent("QBEFilter")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.node?.type !== 'NODE_CONST' && _ctx.node?.value !== 'PAR')
      ? (_openBlock(), _createBlock(_component_QBEOperator, {
          key: 0,
          propNode: _ctx.node,
          onSelectedChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selectedChanged'))),
          onTreeUpdated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('treeUpdated')))
        }, null, 8, ["propNode"]))
      : (_ctx.node?.value === 'PAR')
        ? (_openBlock(), _createBlock(_component_QBEGroup, {
            key: 1,
            propNode: _ctx.node,
            onSelectedChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('selectedChanged'))),
            onTreeUpdated: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('treeUpdated')))
          }, null, 8, ["propNode"]))
        : (_ctx.node?.type === 'NODE_CONST')
          ? (_openBlock(), _createBlock(_component_QBEFilter, {
              key: 2,
              propNode: _ctx.node,
              onSelectedChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('selectedChanged'))),
              onTreeUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('treeUpdated')))
            }, null, 8, ["propNode"]))
          : _createCommentVNode("", true)
  ]))
}